import React, { Component } from "react";
import PropTypes from "prop-types";
import { getProfilePictureUrl } from "../../util";

class ProfilePicture extends Component {
  constructor(props) {
    super(props);

    this.state = {
      failedToLoad: false,
    };
    this.handleError = this.handleError.bind(this);
  }

  handleError(e) {
    this.setState({ failedToLoad: true });
  }

  render() {
    const { userId, size, fallbackUrl, alt = "user avatar", ...rest } = this.props;
    const pictureUrl = getProfilePictureUrl(userId, size);
    const failedToLoad = this.state.failedToLoad;

    return (
      <img
        src={failedToLoad && fallbackUrl ? fallbackUrl : pictureUrl + `?q=${Date.now()}`}
        alt={alt}
        {...rest}
        onError={this.handleError}
      />
    );
  }
}

ProfilePicture.propTypes = {
  userId: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["m", "s", "xs"]),
  fallbackUrl: PropTypes.string,
};

export default ProfilePicture;



// WEBPACK FOOTER //
// ./src/components/ProfilePicture/index.js